"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clock = void 0;
const callable_1 = require("./callable");
class Clock extends callable_1.Callable {
    arity() {
        return 0;
    }
    call(interpreter, args) {
        return Date.now();
    }
}
exports.Clock = Clock;
